import React from 'react';
import { Route, Switch } from 'react-router-dom';
// components
import AuthenticatedUserView from 'refactored/ui/views/authenticatedUserView';
import PageLayout from './ui/page/pageLayout';
import TicketsListPage from './pages/tickets-list-page';
import { ScrollCacheProvider } from './context/use-scroll-cache';
import NewTicketPage from './pages/new-ticket-page';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import routes from 'utils/routes';
import { userIsAuthenticatedRedir } from 'components/auth/hoc';

const EmergenciesModule = ({ match }) => {
  const dispatch = useDispatch();

  const handleBack = () => {
    dispatch(push(`${routes.emergencies}/`));
  };

  const className = '';
  return (
    <AuthenticatedUserView className={className} handleBack={handleBack}>
      <ScrollCacheProvider>
        <PageLayout>
          <Switch>
            <Route path={`${match?.url}/`} exact component={TicketsListPage} />
            <Route path={`${match?.url}/new`} component={NewTicketPage} />
          </Switch>
        </PageLayout>
      </ScrollCacheProvider>
    </AuthenticatedUserView>
  );
};

export default userIsAuthenticatedRedir(EmergenciesModule);
